const messages = {
  title: "Oops! Perché sei qui?",
  description:
    "Siamo spiacenti per il disagio. Sembra tu stia tentando di accedere a una pagina che è stata rimossa o non è mai esistita.",
  backHomeButton: "Torna alla dashboard"
}

export default {
  messages
}
